module.exports = new __parcel__URL__("shop_coming_soon_button.5f34dec4.png").toString();